export default __webpack_public_path__ + "static/media/Mazaj-b2b.31538335.svg";